class WishlistProduct {
    constructor(element) {
        this.element = element;
        this.productHandle = this.element.getAttribute('data-product-handle');
        this.productJustToggle = {
            title: this.element.getAttribute('data-product-name'),
            image: this.element.getAttribute('data-product-image')
        };
        this.init();
        this.element.addEventListener('click', this.handleClick.bind(this));
    }

    init() {
        this.updateClass();
    }

    handleClick() {
        this.toggleWishlist();
        this.showNotification();
    }

    updateClass() {
        let wishlistArray = JSON.parse(localStorage.getItem('wishlist')) || [];
        if (wishlistArray.includes(this.productHandle)) {
            this.element.classList.add('added');
        } else {
            this.element.classList.remove('added');
        }
    }

    toggleWishlist() {
        let wishlistArray = JSON.parse(localStorage.getItem('wishlist')) || [];
        const wishlistNotification = document.getElementById('wishlist-notification');
        wishlistNotification.setAttribute('open', '');

        if (wishlistArray.includes(this.productHandle)) {
            wishlistArray = wishlistArray.filter(item => item !== this.productHandle);
            this.productJustToggle.mode = "removed"
        } else {
            wishlistArray.push(this.productHandle);
            this.productJustToggle.mode = "added"
        }

        localStorage.setItem('wishlist', JSON.stringify(wishlistArray));
        localStorage.setItem('product-just-toggle-wishlist', JSON.stringify(this.productJustToggle));
        this.updateClass();
    }

    showNotification() {
        const productWishlistToggle = localStorage.getItem("product-just-toggle-wishlist");
        const productWishlistToggleObject = JSON.parse(productWishlistToggle);
        const wishlistNotification = document.querySelector(".wishlist-notification .notification-content");
        const wishlistNotificationClose = document.querySelector(".wishlist-notification .button-close");

        if (productWishlistToggleObject.mode === 'added') {
            console.log('true');
            wishlistNotification.innerHTML = `<img src='${productWishlistToggleObject.image}' /> <p>The item ${productWishlistToggleObject.title} has been added to your wishlist</p>`
        } else {
            console.log('false');
            wishlistNotification.innerHTML = `<p>The item ${productWishlistToggleObject.title} has been removed from your wishlist</p>`
        }

        wishlistNotificationClose.addEventListener('click', () => {
            document.querySelector('.wishlist-notification').removeAttribute('open');
        })
    }
}

document.querySelectorAll('.product-wishlist').forEach((element) => {
    new WishlistProduct(element);
});

class GetWishListItems {
    constructor(element) {
        this.element = element;
        this.init();
    }

    async init() {
        const productWishlistArray = localStorage.getItem('wishlist');
        const productWishlistArrayJson = JSON.parse(productWishlistArray) || [];
        const template = this.element.getAttribute('data-view');
        let productHtml = '';

        if (productWishlistArrayJson.length) {
            await Promise.all(productWishlistArrayJson.map(async (productHandle) => {
                productHtml += this.getProductItem(productHandle, template);
            }));
            this.element.innerHTML = productHtml;
            this.getProductHtml();
        } else {
            this.element.innerHTML = '<p>Wishlist is empty.</p>'
        }
    }

    getProductItem(handle, template) {
        if (!template) template = 'card_product';
        return '<div class="product-item" data-include="' + Shopify.routes.root + 'products/' + handle + '/?view=' + template + '"></div>';
    }

    getProductHtml() {
        const elements = document.querySelectorAll(".product-item[data-include]");
        elements.forEach(async (element) => {
            const url = element.getAttribute("data-include");

            try {
                const response = await fetch(url);
                if (response.ok) {
                    const htmlContent = await response.text();

                    // Sử dụng DOMParser để phân tích nội dung HTML
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(htmlContent, 'text/html');
                    const mainContent = doc.getElementById('MainContent');

                    if (mainContent) {
                        element.innerHTML = mainContent.innerHTML;
                        this.removeItem();
                    } else {
                        console.error('No element with id "MainContent" found in the fetched document.');
                    }
                } else {
                    console.error("Error fetching the URL:", response.status, response.statusText);
                }
            } catch (error) {
                console.error("Fetch error:", error);
            }
        });
    }

    removeItem() {
        const removeBtn = this.element.querySelectorAll('.product-wishlist-remove');
        const wishlist = localStorage.getItem('wishlist');
        const wishlistJson = JSON.parse(wishlist);
        removeBtn.forEach((btn) => {
            btn.addEventListener('click', () => {
                const btnAttribute = btn.getAttribute('data-product-handle');
                const wishlistUpdate = wishlistJson.filter((item) => item !== btnAttribute);
                localStorage.setItem('wishlist', JSON.stringify(wishlistUpdate));
                btn.closest('.product-item').style.display = "none";
            })
        })
    }
}

const element = document.querySelector('.wishlist-list');
if (element) {
    new GetWishListItems(element);
}